import type { Middleware } from "@reduxjs/toolkit";
import { clearActiveSparx } from "@/features/sparxsEditor/store/slices/document/documentSlice";
import { setActiveSparx } from "@/features/sparxsEditor/store/slices/document/activeDocument";
import { activeSparxSelectionResolved } from "@/features/sparxsEditor/store/domainActions";
import { rootReducer } from "@/store/app/rootReducer";

export const clearActiveSparxOnSelectionChangeMiddleware: Middleware<
  object,
  ReturnType<typeof rootReducer>
> = (store) => (next) => (action) => {
  let nextFileName: string | undefined;
  if (setActiveSparx.match(action)) {
    nextFileName = action.payload;
  } else if (activeSparxSelectionResolved.match(action)) {
    nextFileName = action.payload.activeSparxFileName;
  }
  if (nextFileName !== undefined) {
    const prev = store.getState().editor.activeSparx;
    if (prev !== nextFileName) {
      store.dispatch(clearActiveSparx());
    }
  }
  return next(action);
};
